import React from 'react';

export default {
  default: <React.Fragment>&#42; </React.Fragment>,
  dagger: <sup>&dagger; </sup>,
};
